<template>
  <div>
      <vue-seamless-scroll :data="listData" :class-option="defaultOption" class="seamless-warp">
          <div class="marquee-wrap">
                <div class="marquee-list">
                  <div
                    class="marquee-item"
                    v-for="(item, index) in listData"
                    :key="index"
                    @click="ranking(item)"
                  >
                    <span class="item-span">
                      <div
                        class="item-index"
                        :class="
                          index == 0
                            ? 'item-color1'
                            : 'item-color4' && index == 1
                            ? 'item-color2'
                            : 'item-color4' && index == 2
                            ? 'item-color3'
                            : 'item-color4'
                        "
                      >
                        {{ index+1 }}
                      </div>
                    </span>
                    <span class="hospital">{{ item.hospitalName }}</span>
                    <span class="name">{{item.userName}}</span>
                    <span class="repair">{{ item.repairNum|| 0}}单</span>
                    <span class="maintain">{{ item.maintainNum||0 }}单</span>
                    <span class="inspection">{{ item.inspectNum||0 }}单</span>
                  </div>
                </div>
              </div>
      </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamless from "vue-seamless-scroll";
export default {
    name:'seamless',
  components: {
    vueSeamless,
  },
  props:{
    listData:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
    }
  },
  methods:{
    ranking(item){
      console.log(item)
      let data = { 
        hospitalId:item.hospitalId,
        type:"ranking"
      }
      this.$emit('Ranking',data)
    }
  },
  computed: {
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 40, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  }
};
</script>
<style scoped>
.seamless-warp{
width: 399px;
 height: 220px;
 overflow: hidden;
}
.marquee-item {
  width: 399px;
  height: 34px;
  /* text-overflow: ellipsis; */
  overflow: hidden;
  /* white-space: nowrap; */
  line-height: 36px;
  color: #fff;
  font-size: 18px;
  background: #071632;
  border: 1px solid #152d58;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 12px;
  padding: 0 5px 0 14px;
  box-sizing: border-box;
}
.marquee-item > span {
  display: inline-block;
  height: 34px;
  overflow: hidden;
}
.item-span {
  display: inline-block;
  text-align: center;
  width: 30px;
}
.item-index {
  width: 22px;
  height: 22px;
  border-radius: 2px;
  line-height: 22px;
  margin-left: 4px;
  margin-top: 5px;
}

.hospital{
    margin-left: 5px;
    width: 85px;
}
.name{
    width: 50px;
    margin-left: 5px;
}
.repair{
    width: 60px;
    margin-left: 5px;
}
.maintain{
    width: 60px;
    margin-left: 5px;
}
.inspection{
    widows: 55px;
    margin-left: 5px;
}
.item-color1 {
  background: #ff0000;
}
.item-color2 {
  background: #ff7000;
}
.item-color3 {
  background: #1664ff;
}
.item-color4 {
  background: #8693a6;
}
/* .animate-up {
  transition: all 0.5s ease-in-out;
  transform: translateY(-40px);
} */
</style>



// WEBPACK FOOTER //
// src/components/seamless.vue